/* https://developers.google.com/tag-manager/enhanced-ecommerce#product-impressions */

import { ECData } from './ecdata.model';
import { ECDataPurchase } from './ecdataPurchase.model';
import { Logger } from './log-service';

declare global {
    interface Window { dataLayer: Array<any>; }
}

export class GTMService {

    debug: Logger;

    constructor(
        private dataLayer: Window['dataLayer'],
        private parent: any
    ) {
        this.debug = new Logger(this.parent.config.debug);
        if (!this.dataLayer)
        {
            this.debug.info('init empty dataLayer');
            this.dataLayer=window.dataLayer ? window.dataLayer : [];
        }
    }
    
    private push(data: any) {
        this.dataLayer.push({ 'ecommerce': null });
        this.dataLayer.push(data);
    };

    trackProductViews(ecDatas: Array<ECData>):any {
        let impressions: Array<any> = [];
        ecDatas.forEach(ecData => {
            impressions.push({
                'id': ecData.id,
                'name': ecData.name,
                'price': ecData.price,
                'brand': ecData.brand,
                'category': ecData.category,
                'variant': ecData.variant,
                'list': ecData.list,
                'position': ecData.position
            });
        });
        return this.push({
            'ecommerce': {
                'currencyCode': this.parent.config.currencyCode,
                'impressions': impressions
            }
        })
    }

    trackProductView(ecData: ECData): any {
        return this.push({
            'ecommerce': {
                'currencyCode': (ecData.currency ? ecData.currency : this.parent.config.currencyCode),
                'impressions': [{
                    'id': ecData.id,
                    'name': ecData.name,
                    'price': ecData.price,
                    'brand': ecData.brand,
                    'category': ecData.category,
                    'variant': ecData.variant,
                    'list': ecData.list,
                    'position': ecData.position
               }]
            }
        })
    }

    followProduct(ecData: ECData): any {
        var pushData:any = {
            'event': 'productClick',
            'ecommerce': {
                'click': {
                    'actionField': {'list': ecData.list},
                    'products': [{
                        'id': ecData.id,
                        'name': ecData.name,
                        'price': ecData.price,
                        'brand': ecData.brand,
                        'category': ecData.category,
                        'variant': ecData.variant,
                        'list': ecData.list,
                        'position': ecData.position
                    }]
                }
            }
        };
        if (ecData.url)
        {
            pushData.eventCallback = function(){
                document.location = ecData.url as Location
            };
        }
        return this.push(pushData);
    }

    trackProductDetail(ecData: ECData): any {
        return this.push({
            'event': 'productView',
            'ecommerce': {
                'detail': {
                    'actionField': ecData.list ? {'list': ecData.list} : {},
                    'products': [{
                        'id': ecData.id,
                        'name': ecData.name,
                        'price': ecData.price,
                        'brand': ecData.brand,
                        'category': ecData.category,
                        'variant': ecData.variant
                    }]
                }
            }
        })
    }

    addCartProduct(ecData: ECData): any {
        var pushData:any = {
            'event': 'addToCart',
            'ecommerce': {
                'currencyCode': (ecData.currency ? ecData.currency : this.parent.config.currencyCode),
                'add': {
                    'actionField': {'list': ecData.list},
                    'products': [{
                        'id': ecData.id,
                        'name': ecData.name,
                        'price': ecData.price,
                        'brand': ecData.brand,
                        'category': ecData.category,
                        'variant': ecData.variant,
                        'quantity': ecData.quantity,
                        'position': ecData.position
                    }]
                }
            }
        };
        return this.push(pushData);
    }

    removeCartProduct(ecData: ECData): any {
        var productData:any = {
            'id': ecData.id,
            'quantity': ecData.quantity
        }
        if (ecData.name) {productData.name = ecData.name}
        if (ecData.price) {productData.price = ecData.price}
        if (ecData.brand) {productData.brand = ecData.brand}
        if (ecData.category) {productData.category = ecData.category}
        if (ecData.variant) {productData.variant = ecData.variant}
        if (ecData.position) {productData.position = ecData.position}
        var pushData:any = {
            'event': 'removeFromCart',
            'ecommerce': {
                'currencyCode': (ecData.currency ? ecData.currency : this.parent.config.currencyCode),
                'remove': {
                    'actionField': {'list': ecData.list},
                    'products': [productData]
                }
            }
        };
        return this.push(pushData);
    }

    steps(step: number, option: string, products: Array<ECData>): any {
        var pushData: object = {
            'event': 'checkout',
            'currencyCode': this.parent.config.currencyCode,
            'ecommerce': {
                'checkout': {
                    'actionField': !option ? {'step': step} : {'step': step, 'option': option},
                    'products': products
                }
            }
        };
        return this.push(pushData);
    }
    
    purchase(actionField: ECDataPurchase, products: Array<ECData>): any {
        var pushData: object = {
            'event': 'purchase',
            'ecommerce': {
                'currencyCode': this.parent.config.currencyCode,
                'purchase': {
                    'actionField': actionField,
                    'products': products
                }
            }
        };
        return this.push(pushData);
    }

}